import { render, staticRenderFns } from "./Guochanhua.vue?vue&type=template&id=46253f2c"
import script from "./Guochanhua.vue?vue&type=script&lang=js"
export * from "./Guochanhua.vue?vue&type=script&lang=js"
import style0 from "./Guochanhua.vue?vue&type=style&index=0&id=46253f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports